<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 5H17.5V6.66667H2.5V5ZM2.5 9.16667H17.5V10.8333H2.5V9.16667ZM2.5 13.3333H17.5V15H2.5V13.3333Z" :fill="iconColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconMenu",
  props: {
    iconName: {
      type: String,
      default: "iconCard",
    },
    width: {
      type: [Number, String],
      default: 15,
    },
    height: {
      type: [Number, String],
      default: 10,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>

<style scoped>

</style>
